import React from 'react';
import SignupWizard from './SignupWizard';
import { TermsOfServiceModal } from './TermsOfServiceModal';

const SignUpPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-gray-100 p-3">
      <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-lg shadow-xl p-6 max-w-2xl w-full">
        <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">Create Your Account</h2>
        
        <SignupWizard />

        <p className="mt-4 text-center text-xs text-gray-600">
          Already have an account? <a href="/login" className="font-medium text-blue-600 hover:underline"> Sign in</a>
        </p>
      </div>
    </div>
  );
};

export default SignUpPage;
